export const LEFTPADDING_MAIN_ITEM = '8px'
export const LEFTPADDING_SUB_ITEM = '10px'
